const DeviceWaterQualityList = () => import('Views/waterQuality/device-water-quality-list');
const DeviceWaterQualityChart = () => import('Views/waterQuality/deviceWaterQuality-chart');

export default[
  { path: '/device-water-quality-list', component: DeviceWaterQualityList },
  { path: '/deviceWaterQuality-chart/:ids?', component: DeviceWaterQualityChart },
];



// WEBPACK FOOTER //
// ./src/router/waterQuality.js